import React from 'react';
import Modal from '../../../../../components/Modal/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import Img from '../../../../../components/Img/Img';
import { setDash } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import './ExcelUploadCouponBrandValidSuccessModal.scss';

const ExcelUploadCouponBrandValidSuccessModal = (props) => {
  const { isOpen, data, onSubmit, closeModal } = props;
  const { brandList, requestCnt, possibleCnt, impossibleCnt } = data;

  return (
    <Modal
      title="쿠폰 사용 가능한 브랜드 엑셀 업로드 가능"
      isOpen={isOpen}
      width={900}
      height={600}
      isFooter={true}
      okText="업로드하기"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="excel-upload-coupon-brand-valid-success-modal-wrap">
        <div className="excel-upload-coupon-brand-valid-success-title">
          <div className="summary">
            <span className="request">
              요청:
              <span>{requestCnt}</span>
            </span>
            <span className="possible">
              가능:
              <span>{possibleCnt}</span>
            </span>
            <span className="impossible">
              불가능:
              <span>{impossibleCnt}</span>
            </span>
          </div>

          <div>모든 요청이 엑셀 업로드가 가능합니다.</div>
        </div>

        <div className="excel-upload-coupon-brand-valid-success-list-section">
          <InfoTable>
            <thead>
              <tr>
                <th>순번</th>
                <th>이미지</th>
                <th>브랜드 ID</th>
                <th>브랜드명</th>
                <th>판매/품절 상품 수</th>
                <th>적용가능 상품 수</th>
                <th>상점 티어</th>
                <th>입점 일자</th>
              </tr>
            </thead>
            <tbody>
              {brandList.map((item, index) => (
                <tr key={index}>
                  <td className="tc">{index + 1}</td>
                  <td className="tc">
                    <Img src={item.url} width={'60px'} height={'60px'} />
                  </td>
                  <td className="tc">{item.storeId}</td>
                  <td className="tc">{item.storeName}</td>
                  <td className="tc">{item.saleSoldOutProductCount}</td>
                  <td className="tc">{`${item.couponApplyAvailableProductCount}(${
                    item.saleSoldOutProductCount > 0
                      ? ((item.couponApplyAvailableProductCount / item.saleSoldOutProductCount) * 100).toFixed(1)
                      : '0'
                  }%)`}</td>
                  <td className="tc">{setDash(item.storeTier)}</td>
                  <td className="tc">{setDateFormat(item.entryDate)}</td>
                </tr>
              ))}
            </tbody>
          </InfoTable>
        </div>
      </div>
    </Modal>
  );
};

export default ExcelUploadCouponBrandValidSuccessModal;
